/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoggedInRouteImport } from './routes/_LoggedIn'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoggedInDashboardRouteImport } from './routes/_LoggedIn/dashboard'
import { Route as LoggedInCadetIndexRouteImport } from './routes/_LoggedIn/cadet/index'
import { Route as LoggedInCadetMobileCameraRouteImport } from './routes/_LoggedIn/cadet/mobile-camera'
import { Route as LoggedInCadetEnrollmentRouteImport } from './routes/_LoggedIn/cadet/enrollment'
import { Route as LoggedInCadetApplicationRouteImport } from './routes/_LoggedIn/cadet/application'
import { Route as LoggedInAttendanceSessionPreviousRouteImport } from './routes/_LoggedIn/attendance/session/previous'
import { Route as LoggedInAttendanceSessionNewRouteImport } from './routes/_LoggedIn/attendance/session/new'
import { Route as LoggedInAttendanceSessionCurrentRouteImport } from './routes/_LoggedIn/attendance/session/current'
import { Route as LoggedInAttendanceSessionSessionIdRouteImport } from './routes/_LoggedIn/attendance/session/$sessionId'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedInRoute = LoggedInRouteImport.update({
  id: '/_LoggedIn',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedInDashboardRoute = LoggedInDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInCadetIndexRoute = LoggedInCadetIndexRouteImport.update({
  id: '/cadet/',
  path: '/cadet/',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInCadetMobileCameraRoute =
  LoggedInCadetMobileCameraRouteImport.update({
    id: '/cadet/mobile-camera',
    path: '/cadet/mobile-camera',
    getParentRoute: () => LoggedInRoute,
  } as any)
const LoggedInCadetEnrollmentRoute = LoggedInCadetEnrollmentRouteImport.update({
  id: '/cadet/enrollment',
  path: '/cadet/enrollment',
  getParentRoute: () => LoggedInRoute,
} as any)
const LoggedInCadetApplicationRoute =
  LoggedInCadetApplicationRouteImport.update({
    id: '/cadet/application',
    path: '/cadet/application',
    getParentRoute: () => LoggedInRoute,
  } as any)
const LoggedInAttendanceSessionPreviousRoute =
  LoggedInAttendanceSessionPreviousRouteImport.update({
    id: '/attendance/session/previous',
    path: '/attendance/session/previous',
    getParentRoute: () => LoggedInRoute,
  } as any)
const LoggedInAttendanceSessionNewRoute =
  LoggedInAttendanceSessionNewRouteImport.update({
    id: '/attendance/session/new',
    path: '/attendance/session/new',
    getParentRoute: () => LoggedInRoute,
  } as any)
const LoggedInAttendanceSessionCurrentRoute =
  LoggedInAttendanceSessionCurrentRouteImport.update({
    id: '/attendance/session/current',
    path: '/attendance/session/current',
    getParentRoute: () => LoggedInRoute,
  } as any)
const LoggedInAttendanceSessionSessionIdRoute =
  LoggedInAttendanceSessionSessionIdRouteImport.update({
    id: '/attendance/session/$sessionId',
    path: '/attendance/session/$sessionId',
    getParentRoute: () => LoggedInRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/test': typeof TestRoute
  '/dashboard': typeof LoggedInDashboardRoute
  '/cadet/application': typeof LoggedInCadetApplicationRoute
  '/cadet/enrollment': typeof LoggedInCadetEnrollmentRoute
  '/cadet/mobile-camera': typeof LoggedInCadetMobileCameraRoute
  '/cadet': typeof LoggedInCadetIndexRoute
  '/attendance/session/$sessionId': typeof LoggedInAttendanceSessionSessionIdRoute
  '/attendance/session/current': typeof LoggedInAttendanceSessionCurrentRoute
  '/attendance/session/new': typeof LoggedInAttendanceSessionNewRoute
  '/attendance/session/previous': typeof LoggedInAttendanceSessionPreviousRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/test': typeof TestRoute
  '/dashboard': typeof LoggedInDashboardRoute
  '/cadet/application': typeof LoggedInCadetApplicationRoute
  '/cadet/enrollment': typeof LoggedInCadetEnrollmentRoute
  '/cadet/mobile-camera': typeof LoggedInCadetMobileCameraRoute
  '/cadet': typeof LoggedInCadetIndexRoute
  '/attendance/session/$sessionId': typeof LoggedInAttendanceSessionSessionIdRoute
  '/attendance/session/current': typeof LoggedInAttendanceSessionCurrentRoute
  '/attendance/session/new': typeof LoggedInAttendanceSessionNewRoute
  '/attendance/session/previous': typeof LoggedInAttendanceSessionPreviousRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_LoggedIn': typeof LoggedInRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/test': typeof TestRoute
  '/_LoggedIn/dashboard': typeof LoggedInDashboardRoute
  '/_LoggedIn/cadet/application': typeof LoggedInCadetApplicationRoute
  '/_LoggedIn/cadet/enrollment': typeof LoggedInCadetEnrollmentRoute
  '/_LoggedIn/cadet/mobile-camera': typeof LoggedInCadetMobileCameraRoute
  '/_LoggedIn/cadet/': typeof LoggedInCadetIndexRoute
  '/_LoggedIn/attendance/session/$sessionId': typeof LoggedInAttendanceSessionSessionIdRoute
  '/_LoggedIn/attendance/session/current': typeof LoggedInAttendanceSessionCurrentRoute
  '/_LoggedIn/attendance/session/new': typeof LoggedInAttendanceSessionNewRoute
  '/_LoggedIn/attendance/session/previous': typeof LoggedInAttendanceSessionPreviousRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/test'
    | '/dashboard'
    | '/cadet/application'
    | '/cadet/enrollment'
    | '/cadet/mobile-camera'
    | '/cadet'
    | '/attendance/session/$sessionId'
    | '/attendance/session/current'
    | '/attendance/session/new'
    | '/attendance/session/previous'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/test'
    | '/dashboard'
    | '/cadet/application'
    | '/cadet/enrollment'
    | '/cadet/mobile-camera'
    | '/cadet'
    | '/attendance/session/$sessionId'
    | '/attendance/session/current'
    | '/attendance/session/new'
    | '/attendance/session/previous'
  id:
    | '__root__'
    | '/'
    | '/_LoggedIn'
    | '/login'
    | '/signup'
    | '/test'
    | '/_LoggedIn/dashboard'
    | '/_LoggedIn/cadet/application'
    | '/_LoggedIn/cadet/enrollment'
    | '/_LoggedIn/cadet/mobile-camera'
    | '/_LoggedIn/cadet/'
    | '/_LoggedIn/attendance/session/$sessionId'
    | '/_LoggedIn/attendance/session/current'
    | '/_LoggedIn/attendance/session/new'
    | '/_LoggedIn/attendance/session/previous'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoggedInRoute: typeof LoggedInRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  TestRoute: typeof TestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_LoggedIn': {
      id: '/_LoggedIn'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LoggedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_LoggedIn/dashboard': {
      id: '/_LoggedIn/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LoggedInDashboardRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/cadet/': {
      id: '/_LoggedIn/cadet/'
      path: '/cadet'
      fullPath: '/cadet'
      preLoaderRoute: typeof LoggedInCadetIndexRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/cadet/mobile-camera': {
      id: '/_LoggedIn/cadet/mobile-camera'
      path: '/cadet/mobile-camera'
      fullPath: '/cadet/mobile-camera'
      preLoaderRoute: typeof LoggedInCadetMobileCameraRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/cadet/enrollment': {
      id: '/_LoggedIn/cadet/enrollment'
      path: '/cadet/enrollment'
      fullPath: '/cadet/enrollment'
      preLoaderRoute: typeof LoggedInCadetEnrollmentRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/cadet/application': {
      id: '/_LoggedIn/cadet/application'
      path: '/cadet/application'
      fullPath: '/cadet/application'
      preLoaderRoute: typeof LoggedInCadetApplicationRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/attendance/session/previous': {
      id: '/_LoggedIn/attendance/session/previous'
      path: '/attendance/session/previous'
      fullPath: '/attendance/session/previous'
      preLoaderRoute: typeof LoggedInAttendanceSessionPreviousRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/attendance/session/new': {
      id: '/_LoggedIn/attendance/session/new'
      path: '/attendance/session/new'
      fullPath: '/attendance/session/new'
      preLoaderRoute: typeof LoggedInAttendanceSessionNewRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/attendance/session/current': {
      id: '/_LoggedIn/attendance/session/current'
      path: '/attendance/session/current'
      fullPath: '/attendance/session/current'
      preLoaderRoute: typeof LoggedInAttendanceSessionCurrentRouteImport
      parentRoute: typeof LoggedInRoute
    }
    '/_LoggedIn/attendance/session/$sessionId': {
      id: '/_LoggedIn/attendance/session/$sessionId'
      path: '/attendance/session/$sessionId'
      fullPath: '/attendance/session/$sessionId'
      preLoaderRoute: typeof LoggedInAttendanceSessionSessionIdRouteImport
      parentRoute: typeof LoggedInRoute
    }
  }
}

interface LoggedInRouteChildren {
  LoggedInDashboardRoute: typeof LoggedInDashboardRoute
  LoggedInCadetApplicationRoute: typeof LoggedInCadetApplicationRoute
  LoggedInCadetEnrollmentRoute: typeof LoggedInCadetEnrollmentRoute
  LoggedInCadetMobileCameraRoute: typeof LoggedInCadetMobileCameraRoute
  LoggedInCadetIndexRoute: typeof LoggedInCadetIndexRoute
  LoggedInAttendanceSessionSessionIdRoute: typeof LoggedInAttendanceSessionSessionIdRoute
  LoggedInAttendanceSessionCurrentRoute: typeof LoggedInAttendanceSessionCurrentRoute
  LoggedInAttendanceSessionNewRoute: typeof LoggedInAttendanceSessionNewRoute
  LoggedInAttendanceSessionPreviousRoute: typeof LoggedInAttendanceSessionPreviousRoute
}

const LoggedInRouteChildren: LoggedInRouteChildren = {
  LoggedInDashboardRoute: LoggedInDashboardRoute,
  LoggedInCadetApplicationRoute: LoggedInCadetApplicationRoute,
  LoggedInCadetEnrollmentRoute: LoggedInCadetEnrollmentRoute,
  LoggedInCadetMobileCameraRoute: LoggedInCadetMobileCameraRoute,
  LoggedInCadetIndexRoute: LoggedInCadetIndexRoute,
  LoggedInAttendanceSessionSessionIdRoute:
    LoggedInAttendanceSessionSessionIdRoute,
  LoggedInAttendanceSessionCurrentRoute: LoggedInAttendanceSessionCurrentRoute,
  LoggedInAttendanceSessionNewRoute: LoggedInAttendanceSessionNewRoute,
  LoggedInAttendanceSessionPreviousRoute:
    LoggedInAttendanceSessionPreviousRoute,
}

const LoggedInRouteWithChildren = LoggedInRoute._addFileChildren(
  LoggedInRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoggedInRoute: LoggedInRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  TestRoute: TestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
